@if (product()?.status?.selectedColor?.sizes) {
    <product-size-selector-layout
        class="is-flex plp-sizes align-middle"
        [product]="product()"
        [sizes]="product().status.selectedColor.sizes"
        [mode]="productSizeMode.SELECT"
        (sizeSelectedEvent)="addToCart($event, product())"
        (checkStockAvailability)="showAvailability($event, product())"
    ></product-size-selector-layout>
}
